var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLockApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 6.66683H14.1663V5.00016C14.1663 2.70016 12.2997 0.833496 9.99967 0.833496C7.69967 0.833496 5.83301 2.70016 5.83301 5.00016V6.66683H4.99967C4.08301 6.66683 3.33301 7.41683 3.33301 8.3335V16.6668C3.33301 17.5835 4.08301 18.3335 4.99967 18.3335H14.9997C15.9163 18.3335 16.6663 17.5835 16.6663 16.6668V8.3335C16.6663 7.41683 15.9163 6.66683 14.9997 6.66683ZM9.99967 14.1668C9.08301 14.1668 8.33301 13.4168 8.33301 12.5002C8.33301 11.5835 9.08301 10.8335 9.99967 10.8335C10.9163 10.8335 11.6663 11.5835 11.6663 12.5002C11.6663 13.4168 10.9163 14.1668 9.99967 14.1668ZM7.49967 6.66683V5.00016C7.49967 3.61683 8.61634 2.50016 9.99967 2.50016C11.383 2.50016 12.4997 3.61683 12.4997 5.00016V6.66683H7.49967Z",
    fill: "#435869"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLockApi);
export default __webpack_public_path__ + "static/media/ic-lock-api.828e817993e39171a79af36c2cbe74a2.svg";
export { ForwardRef as ReactComponent };